// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"4370f7f7","142":"47d54046","813":"0f8fdae4"}[chunkId] + ".chunk.css";
};